import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StageRow } from "../config/pageRows.types";
import { fullWidth } from "../blocks/layout/columnSpans";
import { Button } from "../elements/Button";
import { CancelButton } from "../elements/CancelButton";
import { CheckIcon } from "../icons";
import { EntityPageContent } from "./EntityPageContent";
import { useEntityPage } from "./useEntityPage";

/** A new record's steps, one at a time with its progress above, before the page's own body opens. */
export function EntityWizard() {
  const { wizard, onWizardBack, onWizardContinue } = useEntityPage();

  if (!wizard) {
    return null;
  }

  const rows = [{ columns: [{ span: fullWidth, blocks: [{ kind: "stage", stage: wizard.stage }] }] }] as StageRow[];
  const steps = wizard.titles;

  return (
    <div className="flex-grow-1 min-w-0 overflow-y-auto bg-light p-3 p-md-4">
      <div className="mx-auto d-flex flex-column gap-3" style={{ maxWidth: 960 }}>
        {steps.length > 1 && (
        <ol className="list-unstyled d-flex align-items-center mb-0" aria-label="Progress">
          {steps.map((title, index) => {
            const done = index < wizard.step;
            const current = index === wizard.step;

            return (
              <li
                key={title}
                className={classNames("d-flex align-items-center gap-2", { "flex-grow-1": index < steps.length - 1 })}
                aria-current={current ? "step" : undefined}
              >
                <span
                  className={classNames(
                    "rounded-circle border d-flex align-items-center justify-content-center flex-shrink-0 w-32 h-32 small",
                    done && "bg-primary border-primary text-white",
                    current && "border-primary text-primary bg-white fw-semibold",
                    !done && !current && "bg-white text-body-secondary"
                  )}
                >
                  {done ? <FontAwesomeIcon icon={CheckIcon} /> : index + 1}
                </span>
                <span className={classNames("text-nowrap", current ? "fw-semibold" : "text-body-secondary")}>{title}</span>
                {index < steps.length - 1 && (
                  <span className={classNames("flex-grow-1 border-top mx-2", done ? "border-primary" : "")} />
                )}
              </li>
            );
          })}
        </ol>
        )}
        <div className="page-section">
          <EntityPageContent flat rows={rows} />
          <div className="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
            {wizard.step > 0 && <CancelButton text="Back" title={undefined} onClick={onWizardBack} />}
            <Button
              text="Apply"
              title={undefined}
              variant="none"
              className="entity-page__footer-btn--primary rounded-2 fw-medium"
              onClick={onWizardContinue}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EntityWizard;
